import { gql } from 'apollo-angular';

export const RemoveDashboardDocument = gql`
  mutation removeDashboard($id: Int!) {
    removeDashboard(id: $id)
  }
`;
